import React from 'react';
import { useVerifyIsMobile } from 'hooks/useVerifyIsMobile';
import { HiOutlineChevronLeft } from 'react-icons/hi';
import './style.scss'

export const MobileGenericHeader = ({
  onBack,
  caption,
  containerClassNames = [''],
}) => {
  const { isMobile } = useVerifyIsMobile(768);

  if (!isMobile) return null;

  return (
    <div className="cv-mobile-generic-header">
      <HiOutlineChevronLeft
        onClick={onBack}
        className={[
          'cv-mobile-generic-header__back',
          ...containerClassNames,
        ].join(' ')}
        color="#FFF"
        size={28}
      />
      <h2 className="cv-mobile-generic-header__caption">{caption}</h2>
    </div>
  );
};
